import { render, staticRenderFns } from "./InboxMenu.vue?vue&type=template&id=ef8689c8&scoped=true"
import script from "./InboxMenu.vue?vue&type=script&lang=js"
export * from "./InboxMenu.vue?vue&type=script&lang=js"
import style0 from "./InboxMenu.vue?vue&type=style&index=0&id=ef8689c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef8689c8",
  null
  
)

export default component.exports